module.exports = __webpack_public_path__ + "static/media/tipsImg33.def41b0c.png";